import { createCommonApiResponseSchema } from "@/server/agentTypes";
import { z } from "zod";

export const GetOfferInfoTextResponseSchema = createCommonApiResponseSchema(
  z.object({
    links: z
      .array(
        z.object({
          text: z.string(),
          link: z.string().optional(),
          isRequired: z.boolean().optional(),
        })
      )
      .optional(),
    text: z.string(),
  })
);
